/**
 * `workloadSettingsFromMonday()` — read a `ResourceAllocationBoardView.settings_str`
 * (`specs/M4-V6-workload.md` §2.2). All five production rows are the evidence for every line.
 */
import { columnSelectionFromMonday, singleColumnFromMonday } from '../column-selection.js';
import { extraKeys, parseViewSettingsBlob, presentKeys } from '../from-monday.js';
import { DEFAULT_WORKLOAD_VIEW_SETTINGS, WORKLOAD_MONDAY_KEYS, } from './index.js';
export function workloadSettingsFromMonday(raw) {
    const { object, warnings } = parseViewSettingsBlob(raw, 'workload');
    const d = DEFAULT_WORKLOAD_VIEW_SETTINGS;
    const effortModeRaw = object['effort_column_type'];
    const effortMode = effortModeRaw === 'effort_column' || effortModeRaw === 'default-label-count'
        ? effortModeRaw
        : (effortModeRaw === undefined ? d.effortMode : (warnings.push(`workload: unknown effort_column_type ${String(effortModeRaw)}`), d.effortMode));
    const weightRaw = object['weight_calculation'];
    // Any other weighting is kept verbatim in `mondayExtras` by `extraKeys`? No — the key is
    // modelled, so an unknown value degrades to split, which is monday's default (q426), and the
    // original string is preserved because `mondayKeys` makes the exporter write the model back.
    const weightCalculation = weightRaw === undefined ? null : 'weight_calculation_split';
    if (weightRaw !== undefined && weightRaw !== 'weight_calculation_split') {
        warnings.push(`workload: unknown weight_calculation ${String(weightRaw)}, treated as split`);
    }
    const subItemsRaw = object['sub_items_display_type'];
    if (subItemsRaw !== undefined && subItemsRaw !== 'items') {
        warnings.push(`workload: unknown sub_items_display_type ${String(subItemsRaw)}`);
    }
    const capacityRaw = object['capacity_per_resource'];
    const capacityPerResource = {};
    if (capacityRaw !== null && typeof capacityRaw === 'object' && !Array.isArray(capacityRaw)) {
        for (const [key, value] of Object.entries(capacityRaw)) {
            const parsed = typeof value === 'number' ? value : Number(value);
            if (Number.isFinite(parsed))
                capacityPerResource[key] = parsed;
            else
                warnings.push(`workload: capacity_per_resource.${key} is not a number`);
        }
    }
    const capacityValue = object['default_capacity'];
    if (capacityValue !== undefined && typeof capacityValue !== 'string') {
        warnings.push('workload: default_capacity is not a string');
    }
    return {
        settings: {
            resourceBy: singleColumnFromMonday(object['group_by_id']),
            colorBy: singleColumnFromMonday(object['color_by_id']),
            labelBy: singleColumnFromMonday(object['label_by_id']),
            dateColumns: columnSelectionFromMonday(object['columns']),
            effortMode,
            // monday's key says "byBoardId" and its one real value is a **column** id (`[V6§2.2]`).
            effortColumnId: singleColumnFromMonday(object['effortColumnIdsByBoardId']),
            subItemsDisplayType: subItemsRaw === 'items' ? 'items' : (subItemsRaw === undefined ? null : 'items'),
            defaultCapacity: typeof capacityValue === 'string' ? capacityValue : (capacityValue === undefined ? d.defaultCapacity : String(capacityValue)),
            isDefaultCapacity: typeof object['is_default_capacity'] === 'boolean' ? object['is_default_capacity'] : d.isDefaultCapacity,
            capacityPerResource,
            weightCalculation,
            bucket: d.bucket,
            collapsedResourceKeys: [],
            mondayKeys: presentKeys(object, WORKLOAD_MONDAY_KEYS),
            mondayExtras: extraKeys(object, WORKLOAD_MONDAY_KEYS),
        },
        warnings,
    };
}
//# sourceMappingURL=from-monday.js.map